/* Allbag: strona wstępna nadruku, animacja kroków w nagłówku (kroki = zakładki, sceny w panelu) */
(function () {
  'use strict';
  function init(root) {
    if (root.__abs) return; root.__abs = true;
    var steps = [].slice.call(root.querySelectorAll('[data-abs-step]')), scenes = [].slice.call(root.querySelectorAll('[data-abs-scene]'));
    if (!steps.length || !scenes.length) return;
    var dur = parseInt(root.getAttribute('data-abs-dur'), 10) || 4200, i = 0, timer = null, hover = false, focus = false;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.style.setProperty('--abs-dur', dur + 'ms');
    function show(n) {
      i = ((n % steps.length) + steps.length) % steps.length;
      steps.forEach(function (s, k) { var on = k === i; s.classList.toggle('is-on', on); s.setAttribute('aria-selected', on ? 'true' : 'false'); s.tabIndex = on ? 0 : -1; });
      scenes.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      var qc = root.querySelector('[data-abs-quote]'); if (qc) qc.classList.toggle('is-on', i === 2);
    }
    function paused() { return reduced || hover || focus || document.hidden; }
    function schedule() { clearTimeout(timer); root.classList.toggle('is-paused', hover || focus); if (paused()) return; timer = setTimeout(function () { show(i + 1); schedule(); }, dur); }
    steps.forEach(function (s, k) {
      s.addEventListener('click', function () { show(k); schedule(); });
      s.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); show(k + 1); steps[i].focus(); }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); show(k - 1); steps[i].focus(); }
      });
    });
    var list = root.querySelector('.abs-steps');
    if (list) {
      list.addEventListener('mouseenter', function () { hover = true; schedule(); });
      list.addEventListener('mouseleave', function () { hover = false; schedule(); });
      list.addEventListener('focusin', function () { focus = true; schedule(); });
      list.addEventListener('focusout', function (e) { if (!list.contains(e.relatedTarget)) { focus = false; schedule(); } });
    }
    document.addEventListener('visibilitychange', schedule);
    show(0);
    var started = false;
    function start() { if (started) return; started = true; schedule(); }
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (en) { if (en.some(function (e) { return e.isIntersecting; })) { start(); io.disconnect(); } }, { threshold: 0.2 }); io.observe(root); } else start();
  }
  function initSeo(sec) {
    if (sec.__abs) return; sec.__abs = true;
    var body = sec.querySelector('[data-abs-seo-body]'), btn = sec.querySelector('[data-abs-seo-toggle]'); if (!body || !btn) return;
    if (body.scrollHeight <= body.clientHeight + 8) { body.classList.remove('is-collapsed'); btn.hidden = true; return; }
    btn.addEventListener('click', function () { var open = body.classList.toggle('is-collapsed') === false; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more'); if (!open) sec.scrollIntoView({ block: 'start', behavior: 'smooth' }); });
  }
  function boot() { document.querySelectorAll('[data-abs-hero]').forEach(init); document.querySelectorAll('[data-abs-seo]').forEach(initSeo); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
